export default [
  {
    value: '1h',
    secondsValue: 3600,
    label: '1 Hour',
  },
  {
    value: '1d',
    secondsValue: 86400,
    label: '1 Day',
  },
  {
    value: '3d',
    secondsValue: 259200,
    label: '3 Days',
  },
  {
    value: '7d',
    secondsValue: 604800,
    label: '7 Days',
  },
  {
    value: '10d',
    secondsValue: 864000,
    label: '10 Days',
  },
];
